import { Injectable } from '@angular/core';
import { ErrorEvent, ErrorReporter } from '@mode/shared/contract-common';
import { BugsnagService, Event } from './bugsnag.service';

/**
 * Implements ErrorReporter to send reports to Bugsnag.
 *
 * This is not providedIn: 'root' because we don't want to depend on it directly. Only use ErrorReporter to access this.
 */
@Injectable()
export class BugsnagErrorService implements ErrorReporter {
  constructor(private bugsnagService: BugsnagService) {}

  notify(event: ErrorEvent): void {
    this.bugsnagService.notify(event.error, (bugsnagEvent: Event) => {
      bugsnagEvent.context = event.context ? event.context : bugsnagEvent.context;
      bugsnagEvent.severity = event.severity ? event.severity : bugsnagEvent.severity;
      bugsnagEvent.unhandled = event.unhandled ? event.unhandled : bugsnagEvent.unhandled;
      bugsnagEvent.groupingHash = event.groupingHash ? event.groupingHash : bugsnagEvent.groupingHash;

      if (event.debugInfo) {
        bugsnagEvent.addMetadata('debugInfo', event.debugInfo);
      }
    });
  }
}
